import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { IamvideoService } from 'src/app/core/services/i-am-video/i-am-video.service';
import { delay, map, retry, retryWhen, take } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { ImageCroppedEvent, Dimensions, ImageTransform, base64ToFile } from 'ngx-image-cropper';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';



export interface videoPayloadData {
  url: string;
  text: string;
  id: string;
}
@Component({
  selector: 'app-imvideo',
  templateUrl: './imvideo.component.html',
  styleUrls: ['./imvideo.component.css']
})
export class ImvideoComponent implements OnInit {
  dateValue = 3650 * 1000;

  file: any;
  shortLink: string = "";
  loading: boolean = false;
  jsonData: any;
  trimmedVideoUrl: any;
  shortLinkForImage1: any;
  shortLinkForImage2: any;
  shortLinkForImage3: any;
  file1: any;
  filesList: any[] = [];
  videoTypeList: videoPayloadData[] = [];
  originalFileList: any[] = [];
  text: any;
  videoUrl: any;
  status: any;
  file3: any;
  file2: any;

  trimVideo1Enable: boolean = true;
  trimVideo2Enable: boolean = true;
  trimVideo3Enable: boolean = true;
  trimVideo4Enable: boolean = true;

  show = false;
  fullScreen = true;
  template = ``

  shortLinkForImage4: any;
  url: any;
  format: any;
  url13: any;
  format13: any;
  url3: any;
  format1: any;
  url1: any;
  format2: any;
  url2: any;
  format3: any;
  url4: any;
  format4: any;
  url5: any;
  format5: any;
  url6: any;
  format6: any;
  url7: any;
  format7: any;
  url8: any;
  format8: any;
  url9: any;
  format9: any;
  url10: any;
  format10: any;
  url11: any;
  format11: any;
  url12: any;
  format12: any;
  text1: any;
  image4Text: any;
  image5Text: any;
  image6Text: string = '';
  image7Text: string = '';
  image8Text: string = '';
  video2Text: string = '';
  video3Text: string = '';

  clicked1: boolean = false;
  clicked2: boolean = false;
  clicked3: boolean = false;
  clicked4: boolean = false;
  clicked5: boolean = false;
  clicked6: boolean = false;
  clicked7: boolean = false;
  clicked8: boolean = false;

  clearBtn1: boolean = false;
  clearBtn2: boolean = false;
  clearBtn3: boolean = false;

  myFiles: string[] = [];
  imageChangedEvent: any = '';
  croppedImage: any = '';
  showCropper1: boolean = false;
  showCropper2: boolean = false;
  showCropper3: boolean = false;
  showCropper4: boolean = false;
  showCropper5: boolean = false;
  showCropper6: boolean = false;
  showCropper7: boolean = false;
  showCropper8: boolean = false;


  showCropButton1: boolean = false;
  showCropButton2: boolean = false;
  showCropButton3: boolean = false;
  showCropButton4: boolean = false;
  showCropButton5: boolean = false;
  showCropButton6: boolean = false;
  showCropButton7: boolean = false;
  showCropButton8: boolean = false;

  canvasRotation = 0;
  rotation = 0;
  scale = 1;
  containWithinAspectRatio = false;
  transform: ImageTransform = {};

  showUploadIcon1: boolean = true;
  showUploadIcon2: boolean = true;
  showUploadIcon3: boolean = true;
  showUploadIcon4: boolean = true;
  showUploadIcon5: boolean = true;
  showUploadIcon6: boolean = true;
  showUploadIcon7: boolean = true;
  showUploadIcon8: boolean = true;

  stopCropper1: boolean = true;
  stopCropper2: boolean = true;
  stopCropper3: boolean = true;
  stopCropper4: boolean = true;
  stopCropper5: boolean = true;
  stopCropper6: boolean = true;
  stopCropper7: boolean = true;
  stopCropper8: boolean = true;
  imageBoxDisable: boolean = true;
  videoBoxDisable: boolean = true;
  videoDuration: any;
  imageChangedEvent1: any;

  urls: any[] = [];
  multiples: any[] = [];
  imageChangedEvent2: any;
  imageChangedEvent3: any;
  imageChangedEvent4: any;
  imageChangedEvent5: any;
  imageChangedEvent6: any;
  imageChangedEvent7: any;
  imageChangedEvent8: any;

  croppedImage1: any;
  croppedImage2: any;
  croppedImage3: any;
  croppedImage4: any;
  croppedImage5: any;
  croppedImage6: any;
  croppedImage7: any;
  croppedImage8: any;

  video1trim: boolean = false;
  video2trim: boolean = false;
  video3trim: boolean = false;
  video4trim: boolean = false;

  submitClicked: boolean = false;
  image1flag: boolean = false;
  image2flag: boolean = false;
  image3flag: boolean = false;
  image4flag: boolean = false;
  image5flag: boolean = false;
  image6flag: boolean = false;
  image7flag: boolean = false;
  image8flag: boolean = false;
  video1flag: boolean = false;
  video2flag: boolean = false;
  video3flag: boolean = false;
  video4flag: boolean = false;

  iconDisabled1: boolean = true;
  iconDisabled2: boolean = true;
  iconDisabled3: boolean = true;
  iconDisabled4: boolean = true;
  iconDisabled5: boolean = true;
  iconDisabled6: boolean = true;
  iconDisabled7: boolean = true;
  iconDisabled8: boolean = true;
  iconDisabled9: boolean = true;
  iconDisabled10: boolean = true;
  iconDisabled11: boolean = true;
  iconDisabled12: boolean = true;
  video1url: any;
  response: any;
  image1url: any;
  image3url: any;
  image2url: any;
  bodyClicked: boolean = false;
  introductionClicked: boolean = true;
  conclusionClicked: boolean = false;
  video2url: any;
  video3url: any;
  image4url: any;
  image5url: any;
  image6url: any;
  image7url: any;
  image8url: any;
  video4Text: any;
  video4url: any;
  urlAvailable: boolean = false;
  trimClicked: boolean = false;
  start1: number = 0;
  end1: any;

  nextbtn: boolean = false;

  videoToBeTrimmed: any;
  display: string = "none";
  display1: string = "none";

  jsonData1: any;
  finalPayLoad: any;
  originalFile1: any;
  originalFile2: any;
  originalFile4: any;
  originalFile3: any;
  originalFile5: any;
  originalFile6: any;
  originalFile8: any;
  originalFile7: any;
  currentImage: string = '';
  trimmedVideo3: boolean = false;
  trimmedVideo2: boolean = false;
  trimmedVideo4: boolean = false;
  loaderTrim: boolean = false;
  nextButtonImage: boolean = true;
  trimData: any;
  btnNextEnabled: boolean = true;
  loading1: boolean = true;
  trimCreateBtn: boolean = true;
  userId: any;
  btnUploadEnable: boolean = true;
  trimDuration: any;
  loaderImage1: boolean = false;
  loaderImage2: boolean = false;
  loaderImage3: boolean = false;
  loaderImage4: boolean = false;
  loaderImage5: boolean = false;
  loaderImage6: boolean = false;
  loaderImage7: boolean = false;
  loaderImage8: boolean = false;

  cropImageUrl: any;
  cropImageUrl1: any;
  cropImageUrl2: any;
  event1: ProgressEvent<FileReader>;
  cropbutton1: boolean = true;
  cropbutton2: boolean = true;
  cropbutton3: boolean = true;
  cropbutton4: boolean = true;
  cropbutton5: boolean = true;
  cropbutton6: boolean = true;
  cropbutton7: boolean = true;
  cropbutton8: boolean = true;
  end3: any;
  startMin: number = 0;
  startSec: number = 0;
  totalTime: any;
  image2Box: boolean = false;
  image3Box: boolean = false;
  uploadClicked: boolean = false;
  Router: any;
  hideMin: boolean=true;

  constructor(private cf: ChangeDetectorRef, private router: Router,
    private http: HttpClient, private IamvideoService: IamvideoService,
    private route: ActivatedRoute,

  ) {
    this.userId = route.snapshot.params.id;
    console.log(this.userId)
  }


  ngOnInit(): void {

    this.http.get("assets/images/Iamvideo/matt.json").subscribe(data => {
      this.jsonData = data;

    })
    this.http.get("assets/images/Iamvideo/aj's.json").subscribe(data => {
      this.jsonData1 = data;

    })
    this.http.get("assets/images/Iamvideo/trim.json").subscribe(data => {
      this.trimData = data;

    })


    // this.enableNextStep1();
  }



  iamvideo = new FormGroup({
    uploadVideo: new FormControl('', [Validators.required]),
  });

  async onSelectVideo(event: any, videoType: any, expectedTime: any) {
    var file = event.target.files[0];
    var videoDuration;
    const video = document.createElement('video');

    if (videoType === 'video1') {
      this.iconDisabled9 = false;
      videoDuration = file.duration;

      this.validateVideo(event, 9, 'video1')

      this.video1trim = true;
      this.video2trim = false;
      this.video3trim = false;
      this.video4trim = false;

      this.video1flag = true;
      this.imageBoxDisable = false;

      this.video1url = await this.uploadNext(file);

      // this.enableNextStep1();
      this.trimCreateBtn = false;


      let video1Data = {
        url: this.video1url,
        text: '',
        id: 'video1'
      };
      this.videoTypeList[0] = video1Data;

    }
    else if (videoType === 'video2') {
      this.iconDisabled10 = false;

      videoDuration = file.duration;
      this.validateVideo(event, 5, 'video2')
      this.trimCreateBtn = true;
      this.video2flag = true;
      this.video1trim = false;
      this.video2trim = true;
      this.video3trim = false;
      this.video4trim = false;

      this.video2url = await this.uploadNext(file);
      this.trimCreateBtn = false;

      let video2Data = {
        url: this.video2url,
        text: this.video2Text,
        id: 'video2'
      };
      this.videoTypeList[8] = video2Data;


    }
    else if (videoType === 'video3') {
      this.iconDisabled11 = false;

      videoDuration = file.duration;
      this.validateVideo(event, 4, 'video3')
      this.trimCreateBtn = true;

      this.video1trim = false;
      this.video2trim = false;
      this.video3trim = true;
      this.video4trim = false;
      this.video3flag = true;

      this.video3url = await this.uploadNext(file);
      this.trimCreateBtn = false;

      let video3Data = {
        url: this.video3url,
        text: this.video3Text,
        id: 'video3'
      };
      this.videoTypeList[9] = video3Data;

    }
    else if (videoType === 'video4') {
      this.iconDisabled12 = false;

      videoDuration = file.duration;
      this.validateVideo(event, 4, 'video4')
      this.trimCreateBtn = true;
      this.video1trim = false;
      this.video2trim = false;
      this.video3trim = false;
      this.video4trim = true;
      this.video4flag = true;

      this.video4url = await this.uploadNext(file);
      this.trimCreateBtn = false;
      let video4Data = {
        url: this.video4url,
        text: '',
        id: 'video4'
      };
      this.videoTypeList[10] = video4Data;


    }


  }

  validateVideo(event: any, expectedTime: any, type: any) {
    const inputVideo = event.target.files[0];
    const video = document.createElement('video');
    video.src = window.URL.createObjectURL(inputVideo);
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      this.videoDuration = video.duration.toFixed(2);
      this.hideMin=true;

      if (this.videoDuration >= expectedTime) {
        if (this.videoDuration <= 60) {
          alert("Length of this video is " + (video.duration).toFixed(2) + " sec but the expected is " + expectedTime + " sec. Please trim this video with the tool below.");
         this.hideMin=false;
         
        }
        else if (this.videoDuration >= 60) {
        this.hideMin=true;
          alert("Length of this video is " + (video.duration / 60).toFixed(2) + " min but the expected is " + expectedTime + " sec. Please trim this video  with the tool below.");
          // this.videoDuration =(this.videoDuration/60).toFixed(2);


        }
        if (type == 'video1') {
          if (event.target.files[0].size >= 943718400 && this.videoDuration < 9) {
            alert("File size is too big")
            this.url13 = false;
            this.format13 = false;
          }
          this.trimVideo1Enable = false;
        }
        else if (type == 'video2') {
          if (event.target.files[0].size > 943718400 && this.videoDuration < 5) {
            alert("File size is too big")
            this.url8 = false;
          }
          this.trimVideo2Enable = false;
        }
        else if (type == 'video3') {
          if (event.target.files[0].size > 943718400 && this.videoDuration < 4) {
            alert("File size is too big")
            this.url9 = false;
          }
          this.trimVideo3Enable = false;
        }
        else if (type == 'video4') {
          if (event.target.files[0].size > 943718400 && this.videoDuration < 4) {
            alert("File size is too big")
            this.url10 = false;
          }
          this.trimVideo4Enable = false;
        }

      }
      else if (this.videoDuration < expectedTime) {

        alert("Length of this video is " + video.duration.toFixed(2) + " but the expected is " + expectedTime + " sec . Please upload another video file");

      }

    }

  }

  imageCropEnabled(event: any, fileType: any) {
    if (fileType == 'image1') {

      this.format1 = this.format;
      this.url1 = this.url;
      this.imageChangedEvent1 = event;

    }
    else if (fileType == 'image2') {
      this.format2 = this.format;
      this.url2 = this.url;
      this.imageChangedEvent2 = event;

    }
    else if (fileType == 'image3') {
      this.format3 = this.format;
      this.url3 = this.url;
      this.imageChangedEvent3 = event;


    }
    else if (fileType == 'image4') {
      this.format4 = this.format;
      this.url4 = this.url;
      this.imageChangedEvent4 = event;

    }
    else if (fileType == 'image5') {
      this.format5 = this.format;
      this.url5 = this.url;
      this.imageChangedEvent5 = event;

    }
    else if (fileType == 'image6') {
      this.format6 = this.format;
      this.url6 = this.url;
      this.imageChangedEvent6 = event;

    }
    else if (fileType == 'image7') {
      this.format7 = this.format;
      this.url7 = this.url;
      this.imageChangedEvent7 = event;

    }
    else if (fileType == 'image8') {
      this.format12 = this.format;
      this.url12 = this.url;
      this.imageChangedEvent8 = event;

    }
  }
  async onSelectFile(event: any, fileType: any) {
    this.imageCropEnabled(event, fileType);
    let file = event.target.files && event.target.files[0];
    this.imageChangedEvent = event;
    var newFile = event.target.files[0];

    if (file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      if (file.type.indexOf('image') > -1) {
        this.format = 'image';
      } else if (file.type.indexOf('video') > -1) {
        this.format = 'video';

      }


      reader.onload = async (event) => {
        this.url = (<FileReader>event.target).result;
        if (this.format == 'image') {
          if (fileType == 'image1') {
            this.image1url='';
            this.videoBoxDisable = false;
            this.image1flag = true;
            this.event1 = event
            this.cropbutton1 = true;
            this.format1 = this.format;
            this.url1 = this.url;
            this.originalFile1 = newFile;
            let image1 = await this.uploadNext(newFile);
            this.cropbutton1 = false;
            this.image2Box = true;
            this.imageData(image1, fileType)


          }
          else if (fileType == 'image2') {
            this.image2url='';

            this.videoBoxDisable = false;

            this.image2flag = true;
            this.cropbutton2 = true;
            this.format2 = this.format;
            this.url2 = this.url;
            this.originalFile2 = newFile;

            let image2 = await this.uploadNext(newFile);
            this.cropbutton2 = false;
            this.image3Box = true;
            this.imageData(image2, fileType)

          }
          else if (fileType == 'image3') {
            this.image3url='';

            this.image3flag = true
            this.videoBoxDisable = false;
            this.cropbutton3 = true;

            this.format3 = this.format;
            this.url3 = this.url;
            this.originalFile3 = newFile;
            let image3 = await this.uploadNext(newFile);

            this.cropbutton3 = false;

            let image3Data = {
              url: image3,
              text: '',
              id: 'image3'
            };
            this.videoTypeList[3] = image3Data;

          }
          else if (fileType == 'image4') {
            this.image4url='';

            this.cropbutton4 = true;
            this.image4flag = true;

            this.format4 = this.format;
            this.url4 = this.url;

            this.originalFile4 = newFile;

            let image4 = await this.uploadNext(newFile);
            this.cropbutton4 = false;
            let image4Data = {
              url: image4,
              text: this.image4Text,
              id: 'image4'
            };
            this.videoTypeList[4] = image4Data;
          }
          else if (fileType == 'image5') {
            this.image5url='';

            this.image5flag = true;

            this.cropbutton5 = true;
            this.format5 = this.format;
            this.url5 = this.url;
            this.croppedImage5 = this.image5url;
            this.originalFile5 = newFile;

            let image5 = await this.uploadNext(newFile);

            this.cropbutton5 = false;
            let image5Data = {
              url: image5,
              text: this.image5Text,
              id: 'image5'
            };
            this.videoTypeList[5] = image5Data;
          }
          else if (fileType == 'image6') {
            this.image6url='';

            this.image6flag = true;

            this.cropbutton6 = true;
            this.format6 = this.format;
            this.url6 = this.url;
            this.originalFile6 = newFile;

            let image6 = await this.uploadNext(newFile);
            this.cropbutton6 = false;

            let image6Data = {
              url: image6,
              text: this.image6Text,
              id: 'image6'
            };
            this.videoTypeList[6] = image6Data;
          }
          else if (fileType == 'image7') {
            this.image7url='';

            this.image7flag = true;

            this.cropbutton7 = true;
            this.format7 = this.format;
            this.url7 = this.url;
            this.originalFile7 = newFile;

            let image7 = await this.uploadNext(newFile);
            this.cropbutton7 = false;

            let image7Data = {
              url: image7,
              text: this.image7Text,
              id: 'image7'
            };
            this.videoTypeList[7] = image7Data;
          }
          else if (fileType == 'image8') {
            this.image8url='';

            this.image8flag = true;

            this.cropbutton8 = true;
            this.format12 = this.format;
            this.url12 = this.url;
            this.originalFile8 = newFile;

            let image8 = await this.uploadNext(newFile);
            this.cropbutton8 = false;
            this.enableUpload();
            let image8Data = {
              url: image8,
              text: this.image8Text,
              id: 'image8'
            };
            this.videoTypeList[11] = image8Data;
          }

        }
        else {
          if (fileType == 'video1') {
            this.video1url='';

            this.url13 = this.url;
            this.format13 = this.format;
            // this.enableNextStep1();

          }
          else if (fileType == 'video2') {
            this.video2url='';

            this.url8 = this.url;
            this.format8 = this.format;
            // this.enableNext();

          }
          else if (fileType == 'video3') {
            this.video3url='';

            this.url9 = this.url;
            this.format9 = this.format;
            // this.enableNext();
          }
          else if (fileType == 'video4') {
            this.video4url='';
            this.url10 = this.url;
            this.format10 = this.format;
            // this.enableupload();

          }
        }


      }

    }
    // this.enableNext();
  }
  disable() {
    if (this.stopCropper1 == true || this.stopCropper2 == true || this.stopCropper3 == true) {
      this.nextButtonImage = true;
    }
    else {
      this.nextButtonImage = false;

    }
  }
  disable2() {
    if (this.stopCropper4 == true || this.stopCropper5 == true || this.stopCropper6 == true || this.stopCropper7 == true || this.trimVideo2Enable == true || this.trimVideo3Enable == true) {
      this.btnNextEnabled = true;
    }
    else {
      this.btnNextEnabled = false;

    }
  }

  enableNextStep1() {

    if (this.url1 && this.url2 && this.url3) {
      this.disable();
      this.nextButtonImage = false;
    }
    else if (this.url13 && this.trimmedVideoUrl) {
      this.nextButtonImage = false;
    }

    else {
      this.nextButtonImage = true;
    }
  }
  enableNext() {
    if (this.url4 && this.url5 && this.url6 && this.url7 && this.url8 && this.url9 && this.image4Text && this.image5Text && this.image6Text && this.image7Text && this.video3Text && this.video2Text) {
      this.disable2();
      this.btnNextEnabled = false;
    }
    else {
      this.btnNextEnabled = true;

    }

  }

  enableUpload() {
    if (this.url12 && this.image8Text && this.stopCropper8 == false) {
      this.btnUploadEnable = false;
    }
    else if (this.url10 && this.video4url) {
      this.btnUploadEnable = false;
    }
    else {
      this.btnUploadEnable = true;
    }
  }


  onClear1() {
    this.nextButtonImage = true;
    this.url1 = '';
    this.url12 = '';
    this.url3 = '';
    this.url13 = '';
    this.image1url = '';
    this.image2url = '';
    this.image3url = '';
    this.video1url = '';
    this.imageChangedEvent1 = '';
    this.imageChangedEvent2 = '';
    this.imageChangedEvent3 = '';

    // this.image1url = this.image1url.filter((a) => a !== this.image1url);
    this.image2Box = false;
    this.image3Box = false;

    this.format1 = '';
    this.format2 = '';
    this.format3 = '';

    this.imageChangedEvent = '';
    this.currentImage = '';
    this.cropImageUrl = '';


    this.image1flag = false;
    this.image2flag = false;
    this.image3flag = false;
    this.video1flag = false;

    this.iconDisabled1 = true;
    this.iconDisabled2 = true;
    this.iconDisabled3 = true;
    this.iconDisabled9 = true;




    this.videoBoxDisable = true;
    this.imageBoxDisable = true;

    this.enableNextStep1();
  }
  onClear2() {
    this.url4 = '';
    this.url5 = '';
    this.url6 = '';
    this.url7 = '';
    this.url8 = '';
    this.url9 = '';

    this.image4url = '';
    this.image5url = '';
    this.image6url = '';
    this.image7url = '';
    this.video2url = '';
    this.video3url = '';
    this.imageChangedEvent = '';
    this.imageChangedEvent4 = '';
    this.imageChangedEvent5 = '';
    this.imageChangedEvent6 = '';
    this.imageChangedEvent7 = '';

    this.currentImage = '';
    this.cropImageUrl = '';

    this.iconDisabled4 = true;
    this.iconDisabled5 = true;
    this.iconDisabled6 = true;
    this.iconDisabled7 = true;
    this.iconDisabled10 = true;
    this.iconDisabled11 = true;

    this.image4Text = '';
    this.image5Text = '';
    this.image6Text = '';
    this.image7Text = '';
    this.video2Text = '';
    this.video3Text = '';

    this.image4flag = false;
    this.image5flag = false;
    this.image6flag = false;
    this.image7flag = false;
    this.video2flag = false;
    this.video3flag = false;

    this.trimVideo2Enable = true;
    this.trimVideo3Enable = true;

    this.btnNextEnabled = true;
    this.enableNext();
  }
  onClear3() {
    this.btnUploadEnable = true;
    this.url10 = '';
    this.url12 = '';
    this.image8url = '';
    this.video4url = '';
    this.iconDisabled12 = true;
    this.iconDisabled8 = true;
    this.image8Text = '';

    this.video4flag = false;
    this.image8flag = false;
    this.trimVideo4Enable = true;

    this.enableUpload();
  }
  cropImageData(crop: any, fileType: any): any {
    var i = 0;

    for (i; i < this.originalFileList.length; i++) {
      if (this.originalFileList[i]) {

        if (this.originalFileList[i].fileType == fileType) {

          const file = new File([base64ToFile(crop.base64)],
            this.originalFileList[i].originalFile.name, {
            lastModified: this.originalFileList[i].originalFile.lastModified,
            type: this.originalFileList[i].originalFile.type
          });
          return file;
        }

      }
    }


  }

  imageData(imageurl: any, fileType: any) {
    if (fileType == "image1") {
      this.videoTypeList[1] = {
        url: imageurl,
        text: '',
        id: fileType
      };
    }
    else if (fileType == "image2") {
      this.videoTypeList[2] = {
        url: imageurl,
        text: '',
        id: fileType
      };;

    }
    else if (fileType == "image3") {
      this.videoTypeList[3] = {
        url: imageurl,
        text: '',
        id: fileType
      };;

    }
    else if (fileType == "image4") {
      this.videoTypeList[4] = {
        url: imageurl,
        text: this.image4Text,
        id: fileType
      };;

    }
    else if (fileType == "image5") {
      this.videoTypeList[5] = {
        url: imageurl,
        text: this.image5Text,
        id: fileType
      };;

    }
    else if (fileType == "image6") {
      this.videoTypeList[6] = {
        url: imageurl,
        text: this.image6Text,
        id: fileType
      };;

    }
    else if (fileType == "image7") {
      this.videoTypeList[7] = {
        url: imageurl,
        text: this.image7Text,
        id: fileType
      };;

    }
    else if (fileType == "image8") {
      this.videoTypeList[11] = {
        url: imageurl,
        text: this.image8Text,
        id: fileType
      };;

    }


  }
  timeDuration(time: any, endTime: any): any {


    // const [hours, minutes, seconds] = time.split(':');

    // return Number(hours) * 60 * 60 + Number(minutes) * 60 + Number(seconds);
  }
  validation() {
    this.startMin = this.end1;
    this.startSec = 0;
    this.start1 = 0;
    this.end1 = 0;
    alert("Video duration is " + this.videoDuration + "seconds.Please enter valid start time");

  }

  onSec(remainingSeconds: any, trimDuration: any) {
    if ((this.startSec + 9) >= 60) {
      remainingSeconds = (this.startSec + 9) - 60;
      this.end1 = (this.startMin + 1) + ":" + remainingSeconds;

      console.log(this.end1)
    }
    else {
      this.end1 = this.startMin + ":" + (remainingSeconds + trimDuration);

    }
  }

  onStartClick() {

    this.start1 = this.startMin * 60 + this.startSec;
    if (this.startSec == 60) {
      this.startMin = this.startMin + 1;
      this.startSec = 0;
    }
    if (this.currentImage == 'video1') {
      this.trimDuration = 9;

      if ((this.videoDuration - this.start1) >= this.trimDuration) {

        let remainingSeconds = this.startSec;
        this.onSec(remainingSeconds, this.trimDuration)
      }

      else {
        this.validation()
      }

    }

    else if (this.currentImage == 'video2') {
      this.trimDuration = 5;
      if (this.videoDuration - this.start1 >= this.trimDuration) {
        let remainingSeconds = this.startSec;
        this.onSec(remainingSeconds, this.trimDuration)
      }
      else {
        this.validation()
      }
    }

    else if (this.currentImage == 'video3') {
      this.trimDuration = 4;

      if (this.videoDuration - this.start1 >= this.trimDuration) {
        let remainingSeconds = this.startSec;
        this.onSec(remainingSeconds, this.trimDuration)
      }
      else {
        this.validation()
      }
    }

    else if (this.currentImage == 'video4') {
      this.trimDuration = 4;
      if (this.videoDuration - this.start1 >= this.trimDuration) {
        let remainingSeconds = this.startSec;
        this.onSec(remainingSeconds, this.trimDuration)
      }
      else {
        this.validation()
      }
    }
    console.log(this.end1)
    console.log(this.start1)
  }
  // on(){
  //   this.bodyClicked=true;
  // }
  onBackClick() {
    this.introductionClicked = true;
    this.bodyClicked = false;
    this.conclusionClicked = false


    // this.nextButtonImage = false;
    this.stopCropper1 = false;
    this.stopCropper2 = false;
    this.stopCropper3 = false;



  }
  routeToProfile() {
    this.router.navigate([`/userProfiles/${this.userId}`]);
  }
  go() {
    this.btnNextEnabled = true;
  }
  click1() {
    this.stopCropper1 = true;
    this.enableNextStep1();
  }
  click2() {
    this.stopCropper2 = true;
    this.enableNextStep1();

  }
  click3() {
    this.stopCropper3 = true;
    this.enableNextStep1();

  }
  click4() {
    this.stopCropper4 = true;
  }
  click5() {
    this.stopCropper5 = true;
  }
  click6() {
    this.stopCropper6 = true;
  }
  click7() {
    this.stopCropper7 = true;
  }
  click8() {
    this.stopCropper8 = true;

  }
  onBackClick2() {
    this.btnNextEnabled = true;

    this.stopCropper4 = false;
    this.stopCropper5 = false;
    this.stopCropper6 = false;
    this.stopCropper7 = false;

    this.introductionClicked = false;
    this.bodyClicked = true;
    this.conclusionClicked = false
    // if (this.image4url && this.image5url && this.image6url && this.image7url && this.video2url && this.video3url) {
    //   this.btnNextEnabled = false;
    // }
    // else {
    // }
  }
  trimVideo(videoType: any) {

    this.currentImage = videoType;
    this.end1 = '';
    this.trimDuration = '';
    this.end3 = '';
    this.startMin = 0;
    this.startSec = 0;


    this.onStartClick();
    this.trimmedVideoUrl = '';

    this.trimClicked = true;

    this.videoToBeTrimmed = videoType;

  }

  createvideo() {
    let data = this.trimData;
    data.timeline.tracks[0].clips[0].asset.trim = this.start1;
    // data.timeline.tracks[0].clips[0].asset.trim = this.timeDuration(this.start1,this.end1);
    data.timeline.tracks[0].clips[0].length = this.trimDuration;

    if (this.videoToBeTrimmed == 'video1') {

      data.timeline.tracks[0].clips[0].asset.src = this.video1url;
      this.renderVideo(data, "trim");
      this.enableNextStep1();

    }
    else if (this.videoToBeTrimmed == 'video2') {

      data.timeline.tracks[0].clips[0].asset.src = this.video2url;
      this.renderVideo(data, "trim");
      this.enableNext();
    }
    else if (this.videoToBeTrimmed == 'video3') {

      data.timeline.tracks[0].clips[0].asset.src = this.video3url;
      this.renderVideo(data, "trim");
      this.enableNext();

    }
    else if (this.videoToBeTrimmed == 'video4') {

      data.timeline.tracks[0].clips[0].asset.src = this.video4url;
      this.renderVideo(data, "trim");

      this.enableUpload();
    }
  }
  getFileDetails(e: any) {
    for (var i = 0; i < e.target.files.length; i++) {
      this.myFiles.push(e.target.files[i]);
    }
  }

  uploadVideo() {
    alert(this.videoDuration + 'Length of video is less than 9 sec please change the video');
  }

  imageCropped(event: ImageCroppedEvent, fileType: any) {

    if (fileType == 'image1') {
      if (event && event.base64) {

        this.originalFileList[0] = {
          originalFile: this.originalFile1,
          fileType: "image1",
          event: event
        }
      }

    }

    else if (fileType == 'image2') {
      if (event && event.base64) {
        this.originalFileList[1] = {
          originalFile: this.originalFile2,
          fileType: "image2",
          event: event
        }
      }

    }
    else if (fileType == 'image3') {
      if (event && event.base64) {
        this.originalFileList[2] = {
          originalFile: this.originalFile3,
          fileType: "image3",
          event: event
        }
      }
    }


    else if (fileType == 'image4') {
      this.originalFileList[3] = {
        originalFile: this.originalFile4,
        fileType: "image4",
        event: event
      }
    }
    else if (fileType == 'image5') {
      this.originalFileList[4] = {
        originalFile: this.originalFile5,
        fileType: "image5",
        event: event
      }


    }
    else if (fileType == 'image6') {
      this.originalFileList[5] = {
        originalFile: this.originalFile6,
        fileType: "image6",
        event: event
      }



    }
    else if (fileType == 'image7') {
      this.originalFileList[6] = {
        originalFile: this.originalFile7,
        fileType: "image7",
        event: event
      }



    }
    else if (fileType == 'image8') {
      this.originalFileList[7] = {
        originalFile: this.originalFile8,
        fileType: "image8",
        event: event
      }


    }


  }

  imageLoaded(fileType: any) {
    if (fileType == 'image1') {
      this.showCropper1 = true;
      this.clearBtn1 = true;
      this.showCropButton1 = true;
      this.showUploadIcon1 = false;
      this.clicked1 = false;
      this.iconDisabled1 = false;

    }
    else if (fileType == 'image2') {
      this.showCropper2 = true;
      this.clearBtn1 = true;
      this.showCropButton2 = true;
      this.showUploadIcon2 = false;
      this.clicked2 = false;

      this.iconDisabled2 = false;
    }
    else if (fileType == 'image3') {
      this.showCropper3 = true;
      this.clearBtn1 = true;
      this.showCropButton3 = true;
      this.showUploadIcon3 = false;
      this.clicked3 = false;

      this.iconDisabled3 = false;

    }
    else if (fileType == 'image4') {
      this.showCropper4 = true;
      this.clearBtn2 = true;
      this.showCropButton4 = true;
      this.showUploadIcon4 = false;
      this.clicked4 = false;
      this.iconDisabled4 = false;

    }
    else if (fileType == 'image5') {
      this.showCropper5 = true;
      this.clearBtn2 = true;
      this.showCropButton5 = true;
      this.showUploadIcon5 = false;
      this.clicked5 = false;
      this.iconDisabled5 = false;

    }
    else if (fileType == 'image6') {
      this.showCropper6 = true;
      this.clearBtn2 = true;
      this.showCropButton6 = true;
      this.showUploadIcon6 = false;
      this.clicked6 = false;
      this.iconDisabled6 = false;

    }
    else if (fileType == 'image7') {
      this.showCropper7 = true;
      this.clearBtn2 = true;
      this.showCropButton7 = true;
      this.showUploadIcon7 = false;
      this.clicked7 = false;
      this.iconDisabled7 = false;


    }
    else if (fileType == 'image8') {
      this.showCropper8 = true;
      this.clearBtn3 = true;
      this.showCropButton8 = true;
      this.showUploadIcon8 = false;
      this.clicked8 = false;
      this.iconDisabled8 = false;

    }


  }


  async cropImage(fileType: any) {
    if (fileType == 'image1') {
      this.loaderImage1 = true;

      let file = this.cropImageData(this.originalFileList[0].event, fileType);

      let cropImageUrl = await this.uploadNext(file);
      this.enableNextStep1();

      console.log('image1 url: ', cropImageUrl);
      this.image1url = cropImageUrl;
      this.loaderImage1 = false;

      this.imageData(cropImageUrl, fileType);
      this.showCropButton1 = true;
      this.showCropper1 = false;
      this.clearBtn1 = false;

      this.showUploadIcon1 = false;

    }
    else if (fileType == 'image2') {
      this.loaderImage2 = true;


      this.showCropButton2 = true;
      let file1 = this.cropImageData(this.originalFileList[1].event, fileType);

      let cropImageUrl1 = await this.uploadNext(file1);
      this.enableNextStep1();

      this.image2url = cropImageUrl1
      this.loaderImage2 = false;

      this.imageData(cropImageUrl1, fileType);
      this.showCropper2 = false;
      this.showUploadIcon2 = false;
      this.clearBtn1 = false;

    }
    else if (fileType == 'image3') {

      this.loaderImage3 = true;

      this.showCropButton3 = true;
      let file2 = this.cropImageData(this.originalFileList[2].event, fileType);
      let cropImageUrl2 = await this.uploadNext(file2);
      this.enableNextStep1();

      this.image3url = cropImageUrl2
      this.loaderImage3 = false;

      this.imageData(cropImageUrl2, fileType);
      this.showCropper3 = false;
      this.showUploadIcon3 = false;
      this.clearBtn1 = false;

    }
    else if (fileType == 'image4') {
      if (this.originalFileList[3].event) {
        this.loaderImage4 = true;

        let file3 = this.cropImageData(this.originalFileList[3].event, fileType);
        let cropImageUrl3 = await this.uploadNext(file3);
        this.enableNext()

        this.image4url = cropImageUrl3

        this.loaderImage4 = false;

        this.imageData(cropImageUrl3, fileType);
        this.showCropButton4 = true;
        this.showCropper4 = false;
        this.showUploadIcon4 = false;
        this.clearBtn2 = false;

      }

    }
    else if (fileType == 'image5') {
      if (this.originalFileList[4].event) {
        this.loaderImage5 = true;


        this.showCropButton5 = true;
        let file4 = this.cropImageData(this.originalFileList[4].event, fileType);

        let cropImageUrl4 = await this.uploadNext(file4);
        this.enableNext()

        this.image5url = cropImageUrl4

        this.loaderImage5 = false;

        this.imageData(cropImageUrl4, fileType);
        this.showCropper5 = false;
        this.showUploadIcon5 = false;
        this.clearBtn2 = false;

      }

    }
    else if (fileType == 'image6') {
      if (this.originalFileList[5].event) {
        this.loaderImage6 = true;


        this.showCropButton6 = true;
        let file5 = this.cropImageData(this.originalFileList[5].event, fileType);
        let cropImageUrl5 = await this.uploadNext(file5);
        this.enableNext()

        this.image6url = cropImageUrl5
        this.loaderImage6 = false;

        this.imageData(cropImageUrl5, fileType);
        this.showCropper6 = false;
        this.showUploadIcon6 = false;
        this.clearBtn2 = false;

      }
    }
    else if (fileType == 'image7') {
      if (this.originalFileList[6].event) {
        this.loaderImage7 = true;


        this.showCropButton7 = true;
        let file6 = this.cropImageData(this.originalFileList[6].event, fileType);
        let cropImageUrl6 = await this.uploadNext(file6);
        this.enableNext()

        this.image7url = cropImageUrl6

        this.loaderImage7 = false;

        this.imageData(cropImageUrl6, fileType);
        this.showCropper7 = false;
        this.showUploadIcon7 = false;
        this.clearBtn2 = false;

      }
    }
    else if (fileType == 'image8') {
      if (this.originalFileList[7].event) {
        this.loaderImage8 = true;

        this.image8url = this.originalFileList[7].event.base64

        this.showCropButton8 = true;
        let file7 = this.cropImageData(this.originalFileList[7].event, fileType);

        let cropImageUrl7 = await this.uploadNext(file7);
        this.image8url = cropImageUrl7
        this.loaderImage8 = false;

        this.imageData(cropImageUrl7, fileType);
        this.showCropper8 = false;
        this.showUploadIcon8 = false;
        this.clearBtn3 = false;

      }
    }
  }

  async uploadNext(file: File): Promise<string> {
    const url = await this.IamvideoService.upload(file);
    console.log('public url: ', url);
    return url;
  }

  onUpload() {
    this.uploadClicked = true;

    this.loading = !this.loading;

    let j = 4;
    if (this.videoTypeList[0]) {
      this.finalPayLoad = this.jsonData;
      let k = 0;
      for (let i = 0; i < 9; i++) {
        if (this.videoTypeList[k] && this.videoTypeList[k].url) {
          let imageUrl = this.videoTypeList[k].url;
          this.finalPayLoad.timeline.tracks[1].clips[i].asset.src = imageUrl;
          if (k == 0) {
            k = k + 3;
          }
        }
        k++;
      }
    }
    else {
      this.finalPayLoad = this.jsonData1;
      let k = 1;
      for (let i = 0; i < 11; i++) {
        if (this.videoTypeList[k] && this.videoTypeList[k].url) {
          let imageUrl = this.videoTypeList[k].url;

          this.finalPayLoad.timeline.tracks[1].clips[i].asset.src = imageUrl;
        }
        k++;
      }

    }

    let m = 8;
    for (let i = 1; i < 8; i++) {
      if (this.videoTypeList[j] && this.videoTypeList[j].text) {
        let imageText = "<p>" + this.videoTypeList[j].text + "</p>";
        if (i != 7) {
          this.finalPayLoad.timeline.tracks[0].clips[i].asset.html = imageText;

        }
        this.finalPayLoad.timeline.tracks[0].clips[m].asset.html = imageText;

      }
      if (j == 9) {
        j = j + 1;
      }
      j++;
      m++;
    }

    this.renderVideo(this.finalPayLoad, "final");
    console.log(this.finalPayLoad)
  }

  renderVideo(payload: any, uploadType: any) {
    this.IamvideoService.uploadImage(payload).subscribe(
      data => {
        this.loaderTrim = true;
        this.IamvideoService.getVideo(data.response.id, this.userId, uploadType).pipe(

          map(res => {
            var res = JSON.parse(res);

            if (res.data[0].attributes.status != "ready") {

              throw new Error('Invalid Data')
              console.log(this.finalPayLoad)
            }
            return res.data;


          }),
          retryWhen(errors => errors.pipe(delay(10000), take(10)))
        )
          .subscribe(data => {

            if (uploadType == "final") {
              this.videoUrl = data[0].attributes.url;
              this.urlAvailable = true;

              this.status = data[0].attributes.status;
              this.loading = false;

            }

            else {
              this.trimmedVideoUrl = data[0].attributes.url;
              this.loaderTrim = false;
            }


          })

      }
    );
  }


  backToUpload() {
    this.display1 = "none";
    this.trimClicked = false;
    this.bodyClicked = false;
    this.conclusionClicked = false;
    this.introductionClicked = false;

    if (this.currentImage == "video1") {
      this.url13 = this.trimmedVideoUrl;
      let video1Data = {
        url: this.url13,
        text: '',
        id: 'video1'
      };
      this.videoTypeList[0] = video1Data;
      this.trimVideo1Enable = true;
      this.btn1();

    }
    else if (this.currentImage == "video2") {
      this.url8 = this.trimmedVideoUrl;
      let video2Data = {
        url: this.url8,
        text: this.video2Text,
        id: 'video2'
      };
      this.videoTypeList[8] = video2Data;
      this.trimVideo2Enable = true;
      // this.display1 = "none";
      // this.display = "none";
      this.enableNext();

      this.conclusionClicked = false;
      this.introductionClicked = false;
      this.bodyClicked = true;

    }
    else if (this.currentImage == "video3") {
      this.url9 = this.trimmedVideoUrl
      let video3Data = {
        url: this.url9,
        text: this.video3Text,
        id: 'video3'
      };
      this.videoTypeList[9] = video3Data;
      this.trimVideo3Enable = true;
      this.enableNext();
      this.bodyClicked = true;
      this.conclusionClicked = false;
      this.introductionClicked = false;

    }
    else if (this.currentImage == "video4") {
      this.url10 = this.trimmedVideoUrl
      let video4Data = {
        url: this.url10,
        text: '',
        id: 'video4'
      };
      this.videoTypeList[10] = video4Data;
      this.trimVideo4Enable = true;
      this.conclusionClicked = true;
      this.bodyClicked = false;

      this.introductionClicked = false;
    }
  }
  btn1() {
    if ((this.url1 && this.url2 && this.url3) || this.url13) {
      this.bodyClicked = true;
      this.introductionClicked = false;
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'auto',
      });
      if (this.url || this.image1url && this.image2url && this.image3url) {
        this.loading = false;
      }
      else {
        this.loading = true;
      }

    }
    else {
      alert("You have not fill all the images and videos properly, please  check if you miss to click on crop for images and on trim for video")
      this.bodyClicked = false;
      this.introductionClicked = true;
      this.conclusionClicked = false;
    }

  }
  btn2() {
    if (this.url4 && this.url5 && this.url6 && this.url7 && this.url8 && this.url9 && this.trimmedVideoUrl && this.videoDuration >= this.trimDuration) {
      this.bodyClicked = false;
      this.introductionClicked = false;
      this.conclusionClicked = true;
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'auto',
      });
      this.btnNextEnabled = false;

    }
    else {
      this.enableNext();
      alert("You have not fill all the images and videos properly, please check if you miss to click on crop for images and on trim for video")
      this.btnNextEnabled = true;
      this.bodyClicked = true;
      this.introductionClicked = false;
      this.conclusionClicked = false;
    }

  }
  btn3() {
    if (this.url10 && this.url12 && this.image8Text && this.trimmedVideoUrl && this.videoDuration >= this.trimDuration) {
      this.bodyClicked = false;
      this.introductionClicked = false;
      this.conclusionClicked = true;
      this.btnUploadEnable = false;
      this.onUpload();
    }
    else {
      this.enableUpload();
      alert("Please check if you miss to click on crop for images and on trim for video")
      this.bodyClicked = false;
      this.btnUploadEnable = true;
      this.introductionClicked = false;
      this.conclusionClicked = true;
    }
  }
  openModal() {
    this.currentImage = "image"
    this.display = "block";
    this.croppedImage4 = false;
    this.croppedImage5 = true;
  }
  openModalTrim() {
    this.display1 = "block";
    this.display = "none";
  }
  openModal4() {
    this.currentImage = "image4"
    this.display = "block";
    this.croppedImage4 = true;
    this.croppedImage5 = false;
    this.croppedImage6 = false;
    this.croppedImage7 = false;
    this.croppedImage8 = false;
    this.trimmedVideo2 = false;
    this.trimmedVideo3 = false;
  }
  openModal5() {
    this.currentImage = "image5"
    this.display = "block";
    this.croppedImage5 = true;
    this.croppedImage4 = false;
    this.croppedImage6 = false;
    this.croppedImage7 = false;
    this.croppedImage8 = false;
    this.trimmedVideo2 = false;
    this.trimmedVideo3 = false;
  }
  openModal6() {
    this.currentImage = "image6"
    this.display = "block";
    this.croppedImage6 = true;
    this.croppedImage4 = false;
    this.croppedImage5 = false;
    this.croppedImage7 = false;
    this.croppedImage8 = false;
    this.trimmedVideo2 = false;
    this.trimmedVideo3 = false;
  }
  openModal7() {
    this.currentImage = "image7"
    this.display = "block";
    this.croppedImage7 = true;
    this.croppedImage4 = false;
    this.croppedImage6 = false;
    this.croppedImage5 = false;
    this.croppedImage8 = false;
    this.trimmedVideo2 = false;
    this.trimmedVideo3 = false;
  }
  openModal8() {
    this.currentImage = "video2"
    this.display = "block";
    this.trimmedVideo2 = true;
    this.croppedImage4 = false;
    this.croppedImage5 = false;
    this.croppedImage6 = false;
    this.croppedImage7 = false;
    this.croppedImage8 = false;
    this.trimmedVideo3 = false;

  }
  openModal9() {
    this.currentImage = "video3"
    this.display = "block";
    this.trimmedVideo3 = true;
    this.croppedImage8 = false;
    this.croppedImage4 = false;
    this.croppedImage5 = false;
    this.croppedImage6 = false;
    this.croppedImage7 = false;
    this.trimmedVideo2 = false;
  }
  openModal10() {
    this.currentImage = "image8"
    this.display = "block";
    this.croppedImage8 = true;
    this.croppedImage4 = false;
    this.croppedImage5 = false;
    this.croppedImage6 = false;
    this.croppedImage7 = false;
    this.trimmedVideo2 = false;
    this.trimmedVideo3 = false;

  }


  onCloseHandled() {
    this.display = "none";
    this.display1 = "none";
    this.enableNextStep1();
    this.enableNext();
    this.enableUpload();


  }
  onCloseTextModal() {
    if (this.currentImage.startsWith("image")) {
      this.cropImage(this.currentImage)
      this.submitClicked = true;
    }
    else if (this.currentImage == "video1" || "video2" || "video3" || "video4") {
      this.trimVideo(this.currentImage)
      this.openModalTrim()

    }
    this.display = "none";

  }
}


